import SectionTitle from '@ui/section-title'
import { Container, Row, Col } from '@ui/wrapper'
import TeamMember from '@components/team-member'
import { SectionWrapper, StyledText, StyledContent } from './style'

const EUSIPAArea = ({ data, ...rest }) => {
  return (
    <SectionWrapper {...rest}>
      <Container>
        {data?.section_title &&
          Object.values(data.section_title).some((value) => value != null) && (
            <SectionTitle
              mb={['30px', null, '40px']}
              subtitle={data.section_title?.subtitle}
              title={data.section_title?.title}
            />
          )}
        {data?.texts?.map((text, i) => (
          <StyledText
            key={i}
            dangerouslySetInnerHTML={{
              __html: text.content
            }}
          />
        ))}
        <StyledContent>
          <Row gutters={{ lg: 60 }}>
            {data?.items?.map((member) => (
              <Col md={4} key={member.id} mb="30px">
                <TeamMember
                  layout={2}
                  image={member.images?.[0]}
                  name={member.name}
                  designation={member.designation}
                  socials={member.socials}
                />
              </Col>
            ))}
          </Row>
        </StyledContent>
      </Container>
    </SectionWrapper>
  )
}

export default EUSIPAArea
